import * as React from 'react';

import type { Xinglet } from '@xingternal/crate-xinglet';
import { useLoginAppUrl } from '@xingternal/crate-xinglet';
import { LoggedoutView } from '@xingternal/platform-layout-logged-out';

import { FreeLoggedoutView } from './free-loggedout-view';

type LoggedoutLayoutsProps = {
  isGridless: boolean;
  isFree: boolean;
  children: React.ReactNode;
};
export default class LoggedoutLayouts implements Xinglet {
  public getComponent(): React.VFC<LoggedoutLayoutsProps> {
    return ({ isGridless, isFree, children }): JSX.Element => {
      const loginAppUrl = useLoginAppUrl();

      const View = isFree ? FreeLoggedoutView : LoggedoutView;
      return (
        <View type="standard" gridless={isGridless} loginLink={loginAppUrl}>
          {children}
        </View>
      );
    };
  }
}
